'use client'

import { PROVIDER_ROUTES, ROUTES } from '@/core/constants/routes'
import { safeParseFloat } from '@/core/lib/utils/parse-float'
import { dateService } from '@/core/services/date'
import { useReservationStore } from '@/features/reservation/store'
import { BookForm } from '@/features/reservation/ui'
import { TripDetailsModel } from '@/features/trips/types/models/trip-details.model'
import { useTranslations } from 'next-intl'
import { BookFormModel } from '../../types/models/book-form.model'

const getBookFormInitialValues = (
  trip: TripDetailsModel | null,
): BookFormModel | undefined => {
  if (!trip) return
  return {
    addChildSeats: Boolean(trip.booster || trip.carrier || trip.childSeats),
    booster: trip.booster,
    carrier: trip.carrier,
    checkedLuggage: trip.checkedLuggage,
    childSeats: trip.childSeats,
    countryId: trip.city.countryId,
    date: trip.originalDate,
    time: dateService.timeToDate(trip.time),
    fromPointLat: trip.fromPointLat,
    fromPointLong: trip.fromPointLng,
    fromPointName: trip.fromPointName,
    fromPoint: trip.fromPointName,
    handLuggage: trip.handLuggage,
    passengers: trip.passengers,
    toPointLat: trip.toPointLat,
    toPointLong: trip.toPointLng,
    toPointName: trip.toPointName,
    toPoint: trip.toPointName,
    fromPointDetails: trip.fromPointDetails,
    toPointDetails: trip.toPointDetails,
    country: {
      flag: trip.city.countryFlag || '',
      id: trip.city.countryId,
      name: trip.city.countryName,
      latitude: safeParseFloat(trip.city.latitude || ''),
      longitude: safeParseFloat(trip.city.longitude || ''),
    },
  }
}

type Props = {
  isProvider?: boolean
}

export const UpdateTripBookForm: React.FC<Props> = ({ isProvider }) => {
  const t = useTranslations()
  const trip = useReservationStore(state => state.tripToUpdate)
  if (!trip) {
    return null
  }
  return (
    <BookForm
      submitText={t('actions.updateTrip')}
      nextStep={
        isProvider
          ? PROVIDER_ROUTES.updateTripBookingDetails(trip.id)
          : ROUTES.updateTripBookingDetails(trip.id)
      }
      initialValues={getBookFormInitialValues(trip)}
    />
  )
}
